/**
 * Timber.js - Theme Core JavaScript
 * ============================================================================
 * Table of Contents:
 *
 * 1. Vendor Plugins (prepareTransition, replaceUrlParam)
 * 2. Shopify Helpers (formatMoney, resizeImage, getProduct)
 * 3. Currency Utilities
 * 4. Timber Core (init, caching, modules)
 * 5. Drawer Module
 * 6. Popup Utilities
 * ============================================================================
 */

/* ============================================================================
   1. VENDOR PLUGINS
   ============================================================================ */

/**
 * prepareTransition - Jonathan Snook (MIT License)
 * https://github.com/snookca/prepareTransition
 */
(function ($) {
  var TRANSITION_PROPS = [
    'transition-duration',
    '-moz-transition-duration',
    '-webkit-transition-duration',
    '-o-transition-duration'
  ];

  $.fn.prepareTransition = function () {
    return this.each(function () {
      var $el = $(this);

      $el.one(
        'TransitionEnd webkitTransitionEnd transitionend oTransitionEnd',
        function () {
          $el.removeClass('is-transitioning');
        }
      );

      var hasDuration = TRANSITION_PROPS.some(function (prop) {
        return parseFloat($el.css(prop)) > 0;
      });

      if (hasDuration) {
        $el.addClass('is-transitioning');
        $el[0].offsetWidth; // Force reflow
      }
    });
  };
})(jQuery);

/**
 * replaceUrlParam
 * http://stackoverflow.com/questions/7171099
 */
function replaceUrlParam(url, param, value) {
  var pattern = new RegExp('(' + param + '=).*?(&|$)');

  if (url.search(pattern) >= 0) {
    return url.replace(pattern, '$1' + value + '$2');
  }

  var separator = url.indexOf('?') > 0 ? '&' : '?';
  return url + separator + param + '=' + value;
}

/* ============================================================================
   2. SHOPIFY HELPERS
   ============================================================================ */

if (typeof Shopify === 'undefined') {
  window.Shopify = {};
}

/**
 * Format money values based on Shopify's money format strings.
 * Defined in option_selection.js; redefined here as fallback.
 *
 * @param {number|string} cents - Price in cents
 * @param {string} [format] - Money format string
 * @returns {string} Formatted money string
 */
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function (cents, format) {
    var PLACEHOLDER_REGEX = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    cents = parseInt(cents, 10);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision != null ? precision : 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return '0';
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollars = parts[0].replace(
        /(\d)(?=(\d{3})+(?!\d))/g,
        '$1' + thousands
      );
      var centsStr = parts[1] ? decimal + parts[1] : '';

      return dollars + centsStr;
    }

    var match = formatString.match(PLACEHOLDER_REGEX);
    if (!match) {
      return formatString;
    }

    var value;
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(PLACEHOLDER_REGEX, value);
  };
}

/**
 * Fetch product JSON by handle
 *
 * @param {string} handle - Product handle
 * @param {function} [callback] - Success callback
 */
Shopify.getProduct = function (handle, callback) {
  jQuery.getJSON('/products/' + handle + '.js', function (product) {
    if (typeof callback === 'function') {
      callback(product);
    } else if (typeof Shopify.onProduct === 'function') {
      Shopify.onProduct(product);
    }
  });
};

/**
 * Resize a Shopify image URL to the specified size
 *
 * @param {string} image - Image URL
 * @param {string} size - Size string (e.g., '200x200', 'medium', 'original')
 * @returns {string} Resized image URL
 */
Shopify.resizeImage = function (image, size) {
  if (!image || size === 'original') {
    return image;
  }

  try {
    var matches = image.match(/(.*\/[\w\-_.]+)\.(\w{2,4})/);
    if (matches) {
      return matches[1] + '_' + size + '.' + matches[2];
    }
    return image;
  } catch (e) {
    return image;
  }
};

/* ============================================================================
   3. CURRENCY UTILITIES
   ============================================================================ */

/**
 * Convert a money value using the Currency library (if available)
 * Note: Currently returns unconverted money — kept for API compatibility.
 *
 * @param {number} money - Amount in cents
 * @returns {number} Converted amount
 */
function currencyConverter(money) {
  if (typeof Currency === 'undefined' || typeof shopCurrency === 'undefined') {
    return money;
  }

  Currency.format = 'money_with_currency_format';
  // var cookieCurrency = Currency.cookie.read();
  // var converted = Currency.convert(money, shopCurrency, cookieCurrency);
  return money;
}

/**
 * Re-apply currency conversion to elements matching a selector
 *
 * @param {string} selector - jQuery selector for money elements
 */
function currencyCallback(selector) {
  if (typeof Currency === 'undefined' || typeof shopCurrency === 'undefined') {
    return;
  }

  var $elements = jQuery(selector);
  $elements.each(function () {
    jQuery(this).attr('data-currency-' + shopCurrency, jQuery(this).html());
  });

  Currency.convertAll(
    shopCurrency,
    Currency.cookie.read(),
    selector,
    'money_format'
  );
}

/**
 * Update displayed pricing based on quantity
 *
 * @param {number} [qty] - Quantity override; defaults to #Quantity input value
 */
function updatePricingQty(qty) {
  if (typeof Currency === 'undefined') {
    return;
  }

  Currency.format = 'money_with_currency_format';

  var $selectedVariant = jQuery('#productSelect option:selected');
  if (!$selectedVariant.length) {
    return;
  }

  var variantText = $selectedVariant.text();
  var unitPrice = extractPrice(variantText);

  if (unitPrice === null) {
    return;
  }

  // Determine quantity
  var quantity = qty || parseInt(jQuery('#Quantity').val(), 10) || 1;

  // Calculate total
  var totalPrice = unitPrice * quantity;
  var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
  var formattedTotal = extractPriceString(totalPriceText);

  if (!formattedTotal) {
    return;
  }

  // Get current displayed price
  var $priceEl = jQuery('.engoj_price_main');
  var currentPriceText = extractPriceString($priceEl.text());

  if (!currentPriceText) {
    return;
  }

  // Replace price in HTML
  var regex = new RegExp(escapeRegExp(currentPriceText), 'g');
  var updatedHtml = $priceEl.html().replace(regex, formattedTotal);

  // Uncomment to enable live price update:
  // $priceEl.html(updatedHtml);
}

/**
 * Extract raw price (in cents) from a text string
 *
 * @param {string} text
 * @returns {number|null}
 */
function extractPrice(text) {
  var priceStr = extractPriceString(text);
  if (!priceStr) {
    return null;
  }
  return parseInt(priceStr.replace(/[.,]/g, ''), 10);
}

/**
 * Extract formatted price string from text
 * Matches patterns like "1,234.56" or "1.234,56" or "1,234,567.89"
 *
 * @param {string} text
 * @returns {string|null}
 */
function extractPriceString(text) {
  if (!text) {
    return null;
  }

  // Try complex format first (e.g., 1,234,567.89)
  var match = text.match(/[0-9]+[.,][0-9]+[.,][0-9]+/);
  if (match) {
    return match[0];
  }

  // Simple format (e.g., 123.45)
  match = text.match(/[0-9]+[.,][0-9]+/);
  return match ? match[0] : null;
}

/**
 * Escape special regex characters in a string
 *
 * @param {string} str
 * @returns {string}
 */
function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/* ============================================================================
   4. TIMBER CORE
   ============================================================================ */

window.timber = window.timber || {};

/**
 * Cache frequently accessed DOM elements
 */
timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html: $('html'),
    $body: $('body'),

    // Navigation
    $navigation: $('#AccessibleNav'),
    $mobileSubNavToggle: $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView: $('.engoj-view-mode'),

    // Product Page
    $productImage: $('#ProductPhotoImg'),
    $thumbImages: $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink: $('.RecoverPassword'),
    $hideRecoverPasswordLink: $('.HideRecoverPasswordLink'),
    $recoverPasswordForm: $('.RecoverPasswordForm'),
    $customerLoginForm: $('.CustomerLoginForm'),
    $passwordResetSuccess: $('#ResetSuccess')
  };
};

/**
 * Initialize all Timber modules
 */
timber.init = function () {
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
};

/**
 * Accessible Navigation
 * Handles hover, touch, and keyboard focus for dropdown menus
 */
timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation;

  if (!$nav.length) {
    return;
  }

  var $allLinks = $nav.find('a');
  var $topLevel = $nav.children('li').find('a');
  var $parents = $nav.find('.site-nav--has-dropdown');
  var $subMenuLinks = $nav.find('.site-nav__dropdown').find('a');
  var ACTIVE_CLASS = 'nav-hover';
  var FOCUS_CLASS = 'nav-focus';

  // Mouse / touch events for dropdown parents
  $parents.on('mouseenter touchstart', function (evt) {
    var $el = $(this);
    if (!$el.hasClass(ACTIVE_CLASS)) {
      evt.preventDefault();
    }
    showDropdown($el);
  });

  $parents.on('mouseleave', function () {
    hideDropdown($(this));
  });

  // Prevent touch events on sub-menu links from bubbling
  $subMenuLinks.on('touchstart', function (evt) {
    evt.stopImmediatePropagation();
  });

  // Keyboard focus handling
  $allLinks.on('focus', function () {
    handleFocus($(this));
  });

  $allLinks.on('blur', function () {
    removeFocus($topLevel);
  });

  function handleFocus($el) {
    var isSubItem = $nav.find('.site-nav__dropdown').has($el).length > 0;

    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      var $parentLink = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($parentLink);
    }
  }

  function showDropdown($el) {
    $el.addClass(ACTIVE_CLASS);

    setTimeout(function () {
      timber.cache.$body.on('touchstart.navDropdown', function () {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    $el.removeClass(ACTIVE_CLASS);
    timber.cache.$body.off('touchstart.navDropdown');
  }

  function addFocus($el) {
    $el.addClass(FOCUS_CLASS);
  }

  function removeFocus($el) {
    $el.removeClass(FOCUS_CLASS);
  }
};

/**
 * Initialize Drawer instances
 */
timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');

  var rightDrawerOptions = {};
  
    rightDrawerOptions.onDrawerOpen = ajaxCart.load;
  

  timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', rightDrawerOptions);
};

/**
 * Mobile navigation sub-menu toggle
 */
timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function () {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

/**
 * Get current URL hash
 *
 * @returns {string}
 */
timber.getHash = function () {
  return window.location.hash;
};

/**
 * Product Page variant callback
 * Updates UI based on selected variant state
 *
 * @param {Object} options
 * @param {string} options.money_format
 * @param {Object|null} options.variant
 * @param {Object} options.selector
 */
timber.productPage = function (options) {
  var moneyFormat = options.money_format;
  var variant = options.variant;

  var $productImage = $('#ProductPhotoImg');
  var $addToCart = $('#AddToCart');
  var $productPrice = $('#ProductPrice');
  var $comparePrice = $('#ComparePrice');
  var $quantityElements = $('.quantity-selector, label + .js-qty');
  var $addToCartText = $('#AddToCartText');

  if (!variant) {
    // Variant unavailable — disable purchase
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $quantityElements.hide();
    return;
  }

  // Update variant image if one exists
  if (variant.featured_image) {
    var el = $productImage[0];
    if (el) {
      Shopify.Image.switchImage(variant.featured_image, el, timber.switchImage);
    }
  }

  // Update add-to-cart button state
  if (variant.available) {
    $addToCart.removeClass('disabled').prop('disabled', false);
    $addToCartText.html("Add to Cart");
    $quantityElements.show();
  } else {
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Sold Out");
    $quantityElements.hide();
  }

  // Update price display
  $productPrice.html(Shopify.formatMoney(variant.price, moneyFormat));

  // Update compare-at price
  if (variant.compare_at_price > variant.price) {
    $comparePrice
      .html(
        "Compare at" +
        ' ' +
        Shopify.formatMoney(variant.compare_at_price, moneyFormat)
      )
      .show();
  } else {
    $comparePrice.hide();
  }
};

/**
 * Product thumbnail click handler
 */
timber.productImageSwitch = function () {
  var $thumbs = timber.cache.$thumbImages;

  if (!$thumbs.length) {
    return;
  }

  $thumbs.on('click', function (evt) {
    evt.preventDefault();
    var newImage = $(this).attr('href');
    timber.switchImage(newImage, null, timber.cache.$productImage);
  });
};

/**
 * Switch product image src
 *
 * @param {string} src - New image source URL
 * @param {Object} [imgObject] - Unused, kept for API compatibility
 * @param {jQuery|HTMLElement} el - Target image element
 */
timber.switchImage = function (src, imgObject, el) {
  var $el = $(el);
  $el.attr('src', src);
};

/**
 * Wrap embedded videos for responsive sizing
 */
timber.responsiveVideos = function () {
  var $iframeVideo = $(
    'iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]'
  );

  $iframeVideo.each(function () {
    if (!$(this).parent('.video-wrapper').length) {
      $(this).wrap('<div class="video-wrapper"></div>');
    }
  });

  // Fix Chrome back-button iframe cache bug
  // https://code.google.com/p/chromium/issues/detail?id=395791
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');
  $iframeReset.each(function () {
    this.src = this.src;
  });
};

/**
 * Collection page view mode switcher
 */
timber.collectionViews = function () {
  var $changeView = timber.cache.$changeView;

  if (!$changeView.length) {
    return;
  }

  $changeView.on('click', function () {
    var view = $(this).data('view');
    var url = document.URL;

    if (url.indexOf('?') > -1) {
      window.location = replaceUrlParam(url, 'view', view);
    } else {
      window.location = url + '?view=' + view;
    }
  });
};

/**
 * Customer login / recover password forms
 */
timber.loginForms = function () {
  var cache = timber.cache;

  if (!cache.$recoverPasswordLink.length) {
    return;
  }

  function showRecoverPasswordForm() {
    cache.$recoverPasswordForm.show();
    cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    cache.$recoverPasswordForm.hide();
    cache.$customerLoginForm.show();
  }

  cache.$recoverPasswordLink.on('click', function (evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  cache.$hideRecoverPasswordLink.on('click', function (evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Deep linking support
  if (timber.getHash() === '#recover') {
    showRecoverPasswordForm();
  }
};

/**
 * Show password reset success message
 */
timber.resetPasswordSuccess = function () {
  if (timber.cache && timber.cache.$passwordResetSuccess) {
    timber.cache.$passwordResetSuccess.show();
  }
};

/* ============================================================================
   5. DRAWER MODULE
   ============================================================================ */

timber.Drawers = (function () {
  /**
   * Drawer constructor
   *
   * @param {string} id - Drawer element ID
   * @param {string} position - 'left' or 'right'
   * @param {Object} [options] - Configuration overrides
   */
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.config = $.extend({}, defaults, options);
    this.position = position;
    this.drawerIsOpen = false;
    this.$activeSource = null;

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return;
    }

    this.init();
  }

  Drawer.prototype.init = function () {
    var self = this;

    $(this.config.open).on('click', function (evt) {
      self.open(evt);
    });

    this.$drawer.find(this.config.close).on('click', function (evt) {
      self.close(evt);
    });
  };

  /**
   * Open the drawer
   *
   * @param {Event} [evt] - Click event (optional for programmatic calls)
   */
  Drawer.prototype.open = function (evt) {
    var externalCall = !evt;

    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Prepare transition animations
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    // Apply open classes
    this.$nodes.parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Trap focus inside drawer for accessibility
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run open callback
    if (
      !externalCall &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      this.config.onDrawerOpen();
    }

    // Update aria state
    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock page scroll on touch devices
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    // Close drawer on page click
    var self = this;
    this.$nodes.page.on('click.drawer', function () {
      self.close();
      return false;
    });
  };

  /**
   * Close the drawer
   */
  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) {
      return;
    }

    // Blur any focused elements
    $(document.activeElement).trigger('blur');

    // Prepare close transition
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    // Remove open classes
    this.$nodes.parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Release focus trap
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    // Update aria state
    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    // Remove page event listeners
    this.$nodes.page.off('.drawer');
  };

  /**
   * Trap focus within a container (accessibility)
   *
   * @param {jQuery} $container
   * @param {string} [eventNamespace]
   */
  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace
      ? 'focusin.' + eventNamespace
      : 'focusin';

    $container.attr('tabindex', '-1').focus();

    $(document).on(eventName, function (evt) {
      if (
        $container[0] !== evt.target &&
        !$container.has(evt.target).length
      ) {
        $container.focus();
      }
    });
  };

  /**
   * Remove focus trap
   *
   * @param {jQuery} $container
   * @param {string} [eventNamespace]
   */
  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace
      ? 'focusin.' + eventNamespace
      : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

/* ============================================================================
   6. POPUP UTILITIES
   ============================================================================ */

/**
 * Show a popup element by adding 'active' class
 *
 * @param {string} selector - CSS selector
 */
function showPopup(selector) {
  $(selector).addClass('active');
}
window.showPopup = showPopup;

/**
 * Hide a popup element by removing 'active' class
 *
 * @param {string} selector - CSS selector
 */
function hidePopup(selector) {
  $(selector).removeClass('active');
}
window.hidePopup = hidePopup;

/* ============================================================================
   INITIALIZE
   ============================================================================ */

jQuery(timber.init);
